import { State } from "../../types";

export type SelectActiveDataPointAction = Readonly<{
  key: string;
  type: "SELECT ACTIVE DATA POINT";
}>;

export const selectActiveDataPoint = (state: State, action: SelectActiveDataPointAction): State => {
  if (!(action.key in state.values)) {
    return state;
  }
  return {
    ...state,
    activeValue: action.key,
  };
};
